import { render, staticRenderFns } from "./CallStatistics.vue?vue&type=template&id=e1e47a7c&scoped=true&"
import script from "./CallStatistics.vue?vue&type=script&lang=js&"
export * from "./CallStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1e47a7c",
  null
  
)

export default component.exports